<template lang='pug' src='./braces.pug'></template>

<script>
import api from 'api'
import axios from 'axios'
import Loader from 'components/loader/loader'
import BracesLife from 'components/custom/custom-braces-life/custom-braces-life'
import BracesEating from 'components/custom/custom-braces-eating/custom-braces-eating'
import BracesDoDont from 'components/custom/custom-braces-dodont/custom-braces-dodont'
import FooterMain from 'components/footer/footer-main'

export default {
  name: 'Braces',
  data: () => {
    return {
      name: 'braces',
      props: {},
      message: 'Braces',
      videosource: [],
      loading: true
    }
  },
  created () {
    this.loading = true
    axios.get(api + '/acf/v3/pages/83 ')
      .then(response => {
        this.props = response.data.acf
        this.loading = false
        this.videosource.push(response.data.acf.promo_video_mp4)
        this.videosource.push(response.data.acf.promo_video_webm)
      })
      .catch(e => {
        this.errors.push(e)
        console.log(this.errors.push(e))
        console.log(e)
      })
  },
  components: {
    Loader,
    BracesLife,
    BracesEating,
    BracesDoDont,
    FooterMain
  }
}
</script>



// WEBPACK FOOTER //
// braces.vue?1de3969d